<!-- 一般ユーザー　予約情報入力画面-->
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style scoped>

</style>
<template>
  <div class="container" id="step04">
    <div class="contents">
      <h2>健診予約</h2>
      <section class="flow">
        <h3>予約申し込みの流れ</h3>
        <ol>
          <li>コース選択</li>
          <li>オプション選択</li>
          <li>受診日時選択</li>
          <li>予約情報入力</li>
          <li>予約情報確認</li>
          <li>予約確定</li>
        </ol>
      </section>
	    <!-- ▽  -->
      <section id="mainContents">
        <section class="inputArea">
	        <h3>【お客様情報入力】</h3>
          <p>下記内容を入力して、「入力内容を確認する」ボタンをクリックしてください。</p>
          <div class=note>
          <ul class="listMessage">
            <li v-for="item in inputForm.mem3List" v-bind:key="item">
              {{item}}
            </li>
          </ul>
          </div>
          <table class="inputTbl personalDataTbl">
            <caption><span class="req">「<em>*</em>」の付いた項目は必須入力です。</span></caption>
            <tbody>
              <tr v-if="inputForm.jgnmIsDisplay">
                <th v-bind:class="getRequireClass(inputForm.jgnmIsReactiveErrorCheck,inputForm.jgnmIsErrorCheck)">健康保険組合名</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.jgnmMessage"></errorMessageBalloon>
                  <input type="text" placeholder="" v-model="inputForm.jgnm" v-bind:disabled="!inputForm.jgnmIsInput" v-on:change="reactiveValidationJgnm()">
                </td>
              </tr>
              <tr v-if="inputForm.hkshIsDisplay">
                <th v-bind:class="getRequireClass(inputForm.hkshIsReactiveErrorCheck,inputForm.hkshIsErrorCheck)">保険者番号</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.hkshMessage"></errorMessageBalloon>
                  <input type="text" placeholder="半角数字8桁" maxlength="8" v-model="inputForm.hksh" v-bind:disabled="!inputForm.hkshIsInput" v-on:change="reactiveValidationhksh()">
                  <div>保険者番号が8桁未満の方は左詰めに「0」を入れて8桁にしてください。<br>例）実際の保険者番号：123456 → 入力する場合：00123456</div>
                </td>
              </tr>
					    <tr v-if="inputForm.hkkgIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.hkkgIsReactiveErrorCheck,inputForm.hkkgIsErrorCheck)">保険証記号</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.hkkgMessage"></errorMessageBalloon>
						      <input type="text" placeholder="" maxlength="15" v-model="inputForm.hkkg" v-bind:disabled="!inputForm.hkkgIsInput" v-on:change="reactiveValidationHkkg()">
					      </td>
					    </tr>
					    <tr v-if="inputForm.hknoIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.hknoIsReactiveErrorCheck,inputForm.hknoIsErrorCheck)">保険証番号</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.hknoMessage"></errorMessageBalloon>
					        <input type="text" placeholder="半角数字" maxlength="15" v-model="inputForm.hkno" v-bind:disabled="!inputForm.hknoIsInput" v-on:change="reactiveValidationHkno()">
					      </td>
					    </tr>
					    <tr v-if="inputForm.hfkbIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.hfkbIsReactiveErrorCheck,inputForm.hfkbIsErrorCheck)">対象者区分</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.hfkbMessage"></errorMessageBalloon>
					        <!-- 選んだ健康保険組合（クライアント）に依存 -->
					        <select v-model="inputForm.hfkb" v-bind:disabled="!inputForm.hfkbIsInput" v-on:change="reactiveValidationHfkb()">
					          <option value="">選択してください</option>
						        <option v-for="item in filteredListHfkb" v-bind:value="item.hfkb" v-bind:key="item.hfkb">
						        {{item.kbnm}}
						        </option>
						      </select>
                  <p>※対象者区分についてどれを選んでいいかわからない場合は被保険者をご選択ください。</p>
					      </td>
					    </tr>
					    <tr v-if="inputForm.cmnmIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.cmnmIsReactiveErrorCheck,inputForm.cmnmIsErrorCheck)">企業名</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.cmnmMessage"></errorMessageBalloon>
                  <input type="text" placeholder="" v-model="inputForm.cmnm" v-bind:disabled="!inputForm.cmnmIsInput" v-on:change="reactiveValidationCmnm()">
                </td>
					    </tr>
					    <tr class="name" v-if="(inputForm.ryk1IsDisplay&&inputForm.ryk2IsDisplay) || (inputForm.nam1IsDisplay&&inputForm.nam2IsDisplay)">
					      <th v-bind:class="getRequireClass(inputForm.ryk1IsReactiveErrorCheck,inputForm.ryk1IsErrorCheck)">氏名</th>
					      <td>
					        <ul>
						        <li>
                      <errorMessageBalloon :errorMessages="reactiveValidationError.rykMessage"></errorMessageBalloon>
                      <b>セイ</b><input type="text" placeholder="" v-model="inputForm.ryk1" v-bind:disabled="!inputForm.ryk1IsInput" v-on:change="reactiveValidationRyk()"><b>メイ</b><input type="text" placeholder="" v-model="inputForm.ryk2" v-bind:disabled="!inputForm.ryk2IsInput" v-on:change="reactiveValidationRyk()">
                    </li>
                    <li>
                      <errorMessageBalloon :errorMessages="reactiveValidationError.nameMessage"></errorMessageBalloon>
                      <b>姓</b><input type="text" placeholder="" v-model="inputForm.nam1" v-bind:disabled="!inputForm.nam1IsInput" v-on:change="reactiveValidationName()"><b>名</b><input type="text" placeholder="" v-model="inputForm.nam2" v-bind:disabled="!inputForm.nam2IsInput" v-on:change="reactiveValidationName()">
                    </li>
						      </ul>
					      </td>
					    </tr>
					    <tr v-if="inputForm.btdyYearIsDisplay&&inputForm.btdyMonthIsDisplay&&inputForm.btdyDateIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.btdyYearIsReactiveErrorCheck,inputForm.btdyYearIsErrorCheck)">生年月日</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.btdyMessage"></errorMessageBalloon>
					        <ul class="dayForm">
						        <li>
						          <select v-model="inputForm.btdyYear" v-bind:disabled="!inputForm.btdyYearIsInput" v-on:change="reactiveValidationBtdy()">
							          <option value=0>選択</option>
							          <option v-for="item in inputForm.listBtdyYear" v-bind:key="item">
							            {{item}}
							          </option>
							        </select>
						        </li>
						        <li>
							        <select v-model="inputForm.btdyMonth" v-bind:disabled="!inputForm.btdyMonthIsInput" v-on:change="reactiveValidationBtdy()">
							          <option value=0>選択</option>
							          <option v-for="item in inputForm.listBtdyMonth" v-bind:key="item">
							            {{item}}
							          </option>
							        </select>
						        </li>
						        <li>
							        <!-- 選んだ生年月日　年及び月に依存 -->
							        <select v-model="inputForm.btdyDate" v-bind:disabled="!inputForm.btdyDateIsInput" v-on:change="reactiveValidationBtdy()">
							          <option value=0>選択</option>
							          <option v-for="item in computedListBtdyDate" v-bind:key="item">
								          {{item}}
							          </option>
							        </select>
							      </li>
						      </ul>
						    </td>
					    </tr>
					    <tr v-if="inputForm.ageIsDisplay">
					      <th>年齢</th>
					      <td class="age"><b>{{inputForm.age}}</b><span>（受診日時点での年度年齢を表示しています）</span></td>
					    </tr>
					    <tr v-if="inputForm.sexIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.sexIsReactiveErrorCheck,inputForm.sexIsErrorCheck)">性別</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.sexMessageList"></errorMessageBalloon>
					        <ul class="sex">
					          <li><label class="radio" for="male"><input type="radio" name="sex" id="male" v-bind:value="inputForm.codeSexMan" v-model="inputForm.sex" v-bind:disabled="!inputForm.sexIsInput" v-on:change="reactiveValidationSex()"><span>男性</span></label></li>
					          <li><label class="radio" for="female"><input type="radio" name="sex" id="female" v-bind:value="inputForm.codeSexWoman" v-model="inputForm.sex" v-bind:disabled="!inputForm.sexIsInput" v-on:change="reactiveValidationSex()"><span>女性</span></label></li>
					        </ul>
					      </td>
					    </tr>
					    <tr class="add" v-if="inputForm.zip1IsDisplay&&inputForm.zip2IsDisplay&&inputForm.adr1IsDisplay&&inputForm.adr2IsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.zip1IsReactiveErrorCheck,inputForm.zip1IsErrorCheck)">ご住所</th>
						    <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.zipAddressMessage"></errorMessageBalloon>
                  <div class="note">郵便番号を入力後、「住所検索」をクリックしてください。</div>
						      <ul>
						        <li class="zip">
                      <input type="text" maxlength="3" placeholder="半角数字3桁" v-model="inputForm.zip1" v-bind:disabled="!inputForm.zip1IsInput" v-on:change="reactiveValidationZipAddress()">-<input type="text" maxlength="4" placeholder="半角数字4桁" v-model="inputForm.zip2" v-bind:disabled="!inputForm.zip2IsInput" v-on:change="reactiveValidationZipAddress()">
                      <button v-on:click="onAddressSearch">住所検索</button>
                    </li>
                    <li>
                      <select v-model="inputForm.adr1" v-bind:disabled="!inputForm.adr1IsInput" v-on:change="reactiveValidationZipAddress()">
                        <option value="">都道府県</option>
                        <option v-for="item in inputForm.listAdr1" v-bind:key="item">
                          {{item}}
                        </option>
                      </select>
                    </li>
						        <li><input type="text" placeholder="市区町村" v-model="inputForm.adr2" v-bind:disabled="!inputForm.adr2IsInput" v-on:change="reactiveValidationZipAddress()"></li>
						        <li v-if="inputForm.adr3IsDisplay"><input type="text" placeholder="番地" v-model="inputForm.adr3" v-bind:disabled="!inputForm.adr3IsInput" v-on:change="reactiveValidationZipAddress()"></li>
						      </ul>
					      </td>
					    </tr>
					    <tr class="add" v-if="inputForm.tel1IsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.tel1IsReactiveErrorCheck,inputForm.tel1IsErrorCheck)">電話番号</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.tel1Message"></errorMessageBalloon>
                  <ul>
                    <li class="tel">
                      <input type="text" inputmode="tel" maxlength="20" placeholder="例）XX-XXXX-XXXX" v-model="inputForm.tel1" v-bind:disabled="!inputForm.tel1IsInput" v-on:change="reactiveValidationTel1()">
                      <span class="note">日中ご連絡のとれる電話番号</span>
                    </li>
                  </ul>
                </td>
					    </tr>
					    <tr v-if="inputForm.synoIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.synoIsReactiveErrorCheck,inputForm.synoIsErrorCheck)">社員番号</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.synoMessage"></errorMessageBalloon>
                  <input type="text" placeholder="" maxlength="20" v-model="inputForm.syno" v-bind:disabled="!inputForm.synoIsInput" v-on:change="reactiveValidationSyno()">
                  <div class="note">※申込時に必須と言われている健康保険組合の場合は、入力してください。</div>
                </td>
					    </tr>
					    <tr class="eMail" v-if="inputForm.email1IsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.email1IsReactiveErrorCheck,inputForm.email1IsErrorCheck)">メールアドレス</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.emailMessage"></errorMessageBalloon>
						      <ul>
						        <li><input type="text" maxlength="60" placeholder="" v-model="inputForm.email1" v-bind:disabled="!inputForm.email1IsInput" v-on:change="reactiveValidationEmail()"></li>
						        <li v-if="inputForm.email2IsDisplay"><input type="text" maxlength="60" placeholder="" v-model="inputForm.email2" v-bind:disabled="!inputForm.email2IsInput" v-on:change="reactiveValidationEmail()"></li>
						      </ul>
					      </td>
					    </tr>
					    <tr v-if="inputForm.dmkbIsDisplay">
					      <th v-bind:class="getRequireClass(inputForm.dmkbIsReactiveErrorCheck,inputForm.dmkbIsErrorCheck)">ＤＭ・メルマガ</th>
					      <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.dmkbMessage"></errorMessageBalloon>
						      <ul class="radioLst">
						        <li><label class="radio" for="dmYes"><input type="radio" name="dm" id="dmYes" v-model="inputForm.dmkb" v-bind:value="inputForm.codeDmkbOK" v-bind:disabled="!inputForm.dmkbIsInput" v-on:change="reactiveValidationDmkb()"><span>ＤＭ・メールマガジンを受け取る</span></label></li>
						        <li><label class="radio" for="dmNo"><input type="radio" name="dm" id="dmNo" v-model="inputForm.dmkb" v-bind:value="inputForm.codeDmkbNG" v-bind:disabled="!inputForm.dmkbIsInput" v-on:change="reactiveValidationDmkb()"><span>ＤＭ・メールマガジンを受け取らない</span></label></li>
						      </ul>
					      </td>
					    </tr>
					    <tr v-if="inputForm.mem1IsDisplay">
						    <th v-bind:class="getRequireClass(inputForm.mem1IsReactiveErrorCheck,inputForm.mem1IsErrorCheck)">備考</th>
						    <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.mem1Message">
                  </errorMessageBalloon><textarea placeholder="" v-model="inputForm.mem1" v-bind:disabled="!inputForm.mem1IsInput" v-on:change="reactiveValidationMem1()"></textarea>
                </td>
					    </tr>
				    </tbody>
          </table>
			    <!-- 会員規約から確認するボタンまで START -->
          <div class="accept">
				    <div class="kiyaku">
					    <h4>インターネット予約　会員規約</h4>
					    <textarea v-model="inputForm.cvtn" readonly disabled></textarea>
			        <!-- 会員規約は<textarea>にする必要がある?あるなら要対応 -->
				    </div>
				    <p>入力された個人情報は個人情報保護方針に基づき取り扱われることに同意するものとします。</p>
				    <!-- ▽ 同意確認 -->
				    <ul class="checkLst">
				    	<li><label for="doui" class="checkbox"><input type="checkbox" id="doui" v-model="inputForm.doui"  true-value="1" false-value="2"><span>会員規約および個人情報保護方針に同意します</span></label></li>
				    </ul>
					  <div class="btnLst">
					  	<button class="nextBtn" v-on:click="onNext" v-bind:disabled="computedDoui">入力内容を確認する</button>
					  </div>
			      <!-- 会員規約から確認するボタンまで END -->
          </div>
		    </section>
        <div class="btnLst">
          <button class="backBtn" v-on:click="onBack">戻る</button>
        </div>
      </section>
		  <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
        <dt slot="modal-header">入力エラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonInputReserveInfo } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBalloon from '@/components/Utility/ErrorMessageBalloon'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityValidation from '@/components/Utility/UtilitiValidation'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'
  var YubinBango = require('yubinbango-core2')

  export default {
    // モジュール名
    name: 'CommonInputReserveInfo',
    // 使用コンポーネント
    components: {
      // エラーバルーン（リアクティブエラー表示）
      errorMessageBalloon: ErrorMessageBalloon,
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // 算出プロパティ
    computed: {
      // クライアントでフィルタされた対象者区分
      filteredListHfkb: function () {

        var tempListHfkb = []

        if (this.$store.state.commonUserInfo.newHealthInsurance.jgcd != '') {
          tempListHfkb = this.inputForm.listHfkb
            .filter(item => {
              return item.jgcd == this.$store.state.commonUserInfo.newHealthInsurance.jgcd
            })
        } else {
          tempListHfkb = []
        }
        return tempListHfkb
      },
      // 生年月日　日付のプルダウン内容を生成
      computedListBtdyDate: function () {

        var tempListBtdyDate = []

        // 当月の最終日の求め方
        // 本来8月なら第二引数（月）は7を与えるべきだが
        // 本来8月なら第三引数（日）に0を与えて
        // 次月の最初の日（1日）より一日前（0日）で
        // 当月の最終日を求める
        var lastDate = new Date(
          this.inputForm.btdyYear,
          this.inputForm.btdyMonth, 0).getDate()

        for (var i = 1; i <= lastDate; i++) {
          tempListBtdyDate.push(i)
        }

        return tempListBtdyDate
      },
      // 「入力内容を確認する」ボタンの活性非活性
      // true: this.inputForm.doui=falseすなわち、
      //       戻り値がtrueのときボタン非活性(disabled=true)
      // false: this.inputForm.doui=true
      //       戻り値がtrueのときボタン非活性(disabled=false)
      computedDoui: function() {

        var resultFlag = true

        if('1' == this.inputForm.doui) {
          resultFlag = false
        } else {
          resultFlag = true
        }

        return resultFlag
      }
    },
    // データ
    data() {
      return {

        // ユーザータイプ
        userType: '0',
        // 0: マイページ経由かつ新規予約（個人）
        codeUserTypeMyPageNewIndividual: '0',
        // 1: マイページ経由かつ新規予約（健保）
        codeUserTypeMyPageNewHealth: '1',
        // 2: マイページ経由かつ予約変更（個人）
        codeUserTypeMyPageChangeIndividual: '2',
        // 3: マイページ経由かつ予約変更（健保）
        codeUserTypeMyPageChangeHealth: '3',
        // 4: ゲストログインかつ新規予約（個人）
        codeUserTypeGuestNewIndividual: '4',
        // 5: ゲストログインかつ新規予約（健保）
        codeUserTypeGuestNewHealth: '5',
        // 6: 途中ログインかつ新規予約（個人）
        codeUserTypeEnRouteNewIndividual: '6',
        // 7: 途中ログインかつ新規予約（健保）
        codeUserTypeEnRouteNewHealth: '7',

        // 入力フォーム
        inputForm: {

          // 健康保険組合名
          jgnm: '',
          // 保険者番号
          hksh: '',
          // 保険証記号
          hkkg: '',
          // 保険証番号
          hkno: '',
          // 対象者区分
          hfkb: '',
          // 対象者区分が初期化済みかどうか
          hfkbIsinitializeFlag: false,
          // 対象者区分のプルダウン内容
          // jgcd:クライアントコード
          // hfkb:対象者区分コード
          // kbnm:対象者区分名
          listHfkb:[],
          // 企業名
          cmnm: '',
          // 漢字氏名
          nam1: '',
          nam2: '',
          // カナ氏名
          ryk1: '',
          ryk2: '',
          // 生年月日　年
          btdyYear: 0,
          // 生年月日　月
          btdyMonth: 0,
          // 生年月日　日付
          btdyDate: 0,
          // 生年月日　年のプルダウン内容
          listBtdyYear:[],
          // 生年月日　月のプルダウン内容
          listBtdyMonth: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
          ],
          // 年齢
          age: 0,
          // 性別の選択値 1:男、2:女
          sex: '',
          // 性別 男のコード値
          codeSexMan: '1',
          // 性別 女のコード値
          codeSexWoman: '2',
          // ご住所
          // 郵便番号
          zip1: '',
          zip2: '',
          // 都道府県
          adr1: '',
          // 住所１（市区町村）
          adr2: '',
          // 住所２（番地）
          adr3: '',
          // ご住所 都道府県のプルダウン内容
          listAdr1: [
            '北海道','青森県','岩手県','宮城県','秋田県',
            '山形県','福島県','茨城県','栃木県','群馬県',
            '埼玉県','千葉県','東京都','神奈川県','富山県',
            '石川県','福井県','山梨県','長野県','新潟県',
            '岐阜県','静岡県','愛知県','三重県','滋賀県',
            '京都府','大阪府','兵庫県','奈良県','和歌山県',
            '鳥取県','島根県','岡山県','広島県','山口県',
            '徳島県','香川県','愛媛県','高知県','福岡県',
            '佐賀県','長崎県','熊本県','大分県','宮崎県',
            '鹿児島県','沖縄県'
          ],
          // 電話番号（日中連絡先）
          tel1: '',
          // 社員番号
          syno: '',
          // メールアドレス
          email1: '',
          // 確認用メールアドレス
          email2: '',
          // ＤＭ・メルマガ 0:受け取らない（初期値）、1:受け取る
          dmkb: '0',
          // ＤＭ・メルマガ 受け取らないのコード値
          codeDmkbNG: '0',
          // ＤＭ・メルマガ 受け取るのコード値
          codeDmkbOK: '1',
          // 備考
          mem1: '',

          // インターネット規約文書
          cvtn: '',

          // 予約登録時注意事項
          //mem3: '',
          // 予約登録時注意事項リスト
          mem3List: [],

          // 同意
          doui: false,

          // 初期化の仕方
          // 0: 空文字もしくは0などの定数値
          // 1: ストアから
          // 2: DBから取得
          codeInitializeTypeConstant: '0',
          codeInitializeTypeStore: '1',
          codeInitializeTypeDB: '2',

          // エラーチェック（リアクティブ）
          // 0: エラーチェック行わない
          // 1: エラーチェック行う（必須なし）
          // 2: エラーチェック行う（必須あり）
          codeReactiveErrorCheckNone: '0',
          codeReactiveErrorCheckNoRequired: '1',
          codeReactiveErrorCheckRequired: '2',

          // エラーチェック
          // 0: エラーチェック行わない
          // 1: エラーチェック行う（必須なし）
          // 2: エラーチェック行う（必須あり）
          codeErrorCheckNone: '0',
          codeErrorCheckNoRequired: '1',
          codeErrorCheckRequired: '2',

          // 健康保険組合名
          // 表示非表示フラグ
          jgnmIsDisplay: false,
          // 入力可能かどうか
          jgnmIsInput: false,
          // 初期化の仕方
          jgnmInitializeType: '0',
          // エラーチェックの仕方（リアクティブ）
          jgnmIsReactiveErrorCheck: '0',
          // エラーチェックの仕方
          jgnmIsErrorCheck: '0',

          // 保険者番号
          hkshIsDisplay: false,
          hkshIsInput: false,
          hkshInitializeType: '0',
          hkshIsReactiveErrorCheck: '0',
          hkshIsErrorCheck: '0',

          // 保険証記号
          hkkgIsDisplay: false,
          hkkgIsInput: false,
          hkkgInitializeType: '0',
          hkkgIsReactiveErrorCheck: '0',
          hkkgIsErrorCheck: '0',

          // 保険証番号
          hknoIsDisplay: false,
          hknoIsInput: false,
          hknoInitializeType: '0',
          hknoIsReactiveErrorCheck: '0',
          hknoIsErrorCheck: '0',

          // 対象者区分
          hfkbIsDisplay: false,
          hfkbIsInput: false,
          hfkbInitializeType: '0',
          hfkbIsReactiveErrorCheck: '0',
          hfkbIsErrorCheck: '0',

          // 企業名
          cmnmIsDisplay: false,
          cmnmIsInput: false,
          cmnmInitializeType: '0',
          cmnmIsReactiveErrorCheck: '0',
          cmnmIsErrorCheck: '0',

          // 漢字氏名
          // 姓
          nam1IsDisplay: false,
          nam1IsInput: false,
          nam1InitializeType: '0',
          nam1IsReactiveErrorCheck: '0',
          nam1IsErrorCheck: '0',
          // 名
          nam2IsDisplay: false,
          nam2IsInput: false,
          nam2InitializeType: '0',
          nam2IsReactiveErrorCheck: '0',
          nam2IsErrorCheck: '0',

          // カナ氏名
          // 姓
          ryk1IsDisplay: false,
          ryk1IsInput: false,
          ryk1InitializeType: '0',
          ryk1IsReactiveErrorCheck: '0',
          ryk1IsErrorCheck: '0',
          // 名
          ryk2IsDisplay: false,
          ryk2IsInput: false,
          ryk2InitializeType: '0',
          ryk2IsReactiveErrorCheck: '0',
          ryk2IsErrorCheck: '0',

          // 生年月日
          // 年
          btdyYearIsDisplay: false,
          btdyYearIsInput: false,
          btdyYearInitializeType: '0',
          btdyYearIsReactiveErrorCheck: '0',
          btdyYearIsErrorCheck: '0',
          // 月
          btdyMonthIsDisplay: false,
          btdyMonthIsInput: false,
          btdyMonthInitializeType: '0',
          btdyMonthIsReactiveErrorCheck: '0',
          btdyMonthIsErrorCheck: '0',
          // 日
          btdyDateIsDisplay: false,
          btdyDateIsInput: false,
          btdyDateInitializeType: '0',
          btdyDateIsReactiveErrorCheck: '0',
          btdyDateIsErrorCheck: '0',

          // 年齢
          ageIsDisplay: false,
          ageIsInput: false,
          ageInitializeType: '0',
          ageIsReactiveErrorCheck: '0',
          ageIsErrorCheck: '0',

          // 性別
          sexIsDisplay: false,
          sexIsInput: false,
          sexInitializeType: '0',
          sexIsReactiveErrorCheck: '0',
          sexIsErrorCheck: '0',

          // ご住所
          // 郵便番号 前半
          zip1IsDisplay: false,
          zip1IsInput: false,
          zip1InitializeType: '0',
          zip1IsReactiveErrorCheck: '0',
          zip1IsErrorCheck: '0',

          // 郵便番号 後半
          zip2IsDisplay: false,
          zip2IsInput: false,
          zip2InitializeType: '0',
          zip2IsReactiveErrorCheck: '0',
          zip2IsErrorCheck: '0',

          // 都道府県
          adr1IsDisplay: false,
          adr1IsInput: false,
          adr1InitializeType: '0',
          adr1IsReactiveErrorCheck: '0',
          adr1IsErrorCheck: '0',

          // 住所１（市区町村）
          adr2IsDisplay: false,
          adr2IsInput: false,
          adr2InitializeType: '0',
          adr2IsReactiveErrorCheck: '0',
          adr2IsErrorCheck: '0',

          // 住所２（番地）
          adr3IsDisplay: false,
          adr3IsInput: false,
          adr3InitializeType: '0',
          adr3IsReactiveErrorCheck: '0',
          adr3IsErrorCheck: '0',

          // 電話番号
          tel1IsDisplay: false,
          tel1IsInput: false,
          tel1InitializeType: '0',
          tel1IsReactiveErrorCheck: '0',
          tel1IsErrorCheck: '0',

          // 社員番号
          synoIsDisplay: false,
          synoIsInput: false,
          synoInitializeType: '0',
          synoIsReactiveErrorCheck: '0',
          synoIsErrorCheck: '0',

          // メールアドレス
          email1IsDisplay: false,
          email1IsInput: false,
          email1InitializeType: '0',
          email1IsReactiveErrorCheck: '0',
          email1IsErrorCheck: '0',

          email2IsDisplay: false,
          email2IsInput: false,
          email2InitializeType: '0',
          email2IsReactiveErrorCheck: '0',
          email2IsErrorCheck: '0',

          // ＤＭ・メルマガ
          dmkbIsDisplay: false,
          dmkbIsInput: false,
          dmkbInitializeType: '0',
          dmkbIsReactiveErrorCheck: '0',
          dmkbIsErrorCheck: '0',

          // 備考
          mem1IsDisplay: false,
          mem1IsInput: false,
          mem1InitializeType: '0',
          mem1IsReactiveErrorCheck: '0',
          mem1IsErrorCheck: '0',

        },
        // リアクティブエラー
        reactiveValidationError: {
          // クライアントコード
          // エラーメッセージ
          jgnmMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          jgnmInputFlag: false,
          // 保険者番号
          // エラーメッセージ
          hkshMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          hkshInputFlag: false,
          // 保険証記号
          // エラーメッセージ
          hkkgMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          hkkgInputFlag: false,
          // 保険証番号
          // エラーメッセージ
          hknoMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          hknoInputFlag: false,
          // 対象者区分
          // エラーメッセージ
          hfkbMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          hfkbInputFlag: false,
          // 企業名
          // エラーメッセージ
          cmnmMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          cmnmInputFlag: false,
          // 漢字氏名
          // エラーメッセージ
          nameMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          nam1InputFlag: false,
          nam2InputFlag: false,
          // カナ氏名
          // エラーメッセージ
          rykMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          ryk1InputFlag: false,
          ryk2InputFlag: false,
          // 生年月日
          // エラーメッセージ
          btdyMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          btdyYearInputFlag: false,
          btdyMonthInputFlag: false,
          btdyDateInputFlag: false,
          // 性別
          // エラーメッセージ
          sexMessageList: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          sexInputFlag: false,
          // ご住所
          // 住所全体のエラーメッセージ
          zipAddressMessage: '',
          // 郵便番号
          // 入力済みフラグ（一度でも入力しているかどうか）
          zip1InputFlag: false,
          zip2InputFlag: false,
          // 住所
          // 入力済みフラグ（一度でも入力しているかどうか）
          adr1InputFlag: false,
          adr2InputFlag: false,
          // 電話番号（日中連絡先）
          // エラーメッセージ
          tel1Message: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          tel1InputFlag: false,
          // 社員番号
          // エラーメッセージ
          synoMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          synoInputFlag: false,
          // メールアドレス
          // エラーメッセージ
          emailMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          email1InputFlag: false,
          email2InputFlag: false,
          // ＤＭ・メルマガ
          // エラーメッセージ
          dmkbMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          dmkbInputFlag: false,
          // 備考
          // エラーメッセージ
          mem1Message: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          mem1InputFlag: false,
        },
        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonInputReserveInfo::created Start')

      // テスト用ストア値生成
      /*this.$store.commit(
         types.COMMON_INPUTRESERVEINFO_TEST0)*/

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonInputReserveInfo::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::firstDisplay Start')

        // クライアントコード
        // 00000000は個人固定
        var tempJgcd = ''

        if('' != this.$store.state.commonUserInfo.newHealthInsurance.jgcd) {
          tempJgcd = this.$store.state.commonUserInfo.newHealthInsurance.jgcd
        } else {
          tempJgcd = responce.data.jgcd
        }

        // 画面を構成する要素の初期値を取得する
        CommonInputReserveInfo.FirstDisplay({
          ircd: this.$store.state.auth.ircd,
          jgcd: tempJgcd,
          nend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
          kscd: this.$store.state.commonUserInfo.selectCourse.kscd,
          trsq: this.$store.state.auth.trsq
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            // 各プルダウン用リストを取得
            this.inputForm.listBtdyYear = responce.data.listBtdyYear
            this.inputForm.listHfkb = responce.data.listHfkb

            this.inputForm.cvtn = responce.data.cvtn

            //this.inputForm.mem3 = responce.data.mem3
            this.inputForm.mem3List = responce.data.mem3List

            // ユーザータイプを決める
            this.userType = this.getUserType(tempJgcd)

            // ユーザータイプによってそれぞれ初期化を行う
            this.setInitializeValue()

            // 確認画面からの戻り遷移でなければ
            // 初期化パラメーターに基づき初期化
            // 戻り遷移ならばストア値を引き継ぐ
            if(!this.$store.state.commonUserInfo.confirmReserveInfo.isUse) {
              this.initialize(
                responce.data.jgnm,responce.data.hksh,responce.data.hkkg,
                responce.data.hkno,responce.data.hfkb,responce.data.cmnm,
                responce.data.nam1,responce.data.nam2,responce.data.ryk1,responce.data.ryk2,
                responce.data.btdyYear,responce.data.btdyMonth,responce.data.btdyDate,
                responce.data.age,responce.data.sex,
                responce.data.zip1,responce.data.zip2,
                responce.data.adr1,responce.data.adr2,responce.data.adr3,
                responce.data.tel1,responce.data.syno,responce.data.email,
                responce.data.dmkb,responce.data.mem1)
            } else {
              this.initializeBack()
            }

            // ストアに登録
            this.$store.commit(
              types.COMMON_INPUTRESERVEINFO_FIRSTDISPLAY)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::firstDisplay End')
	      })
      },
      // 表示系--------------------------------------------------E
      // イベント系--------------------------------------------------S
      // 入力内容を確認するボタン押下時
      onNext: function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onNext Start')

        var errorMessagesList = this.validationOnNext()

        if (errorMessagesList.length > 0) {
          this.onValidationErrorModalOpen(errorMessagesList)
          UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onNext End')
          return;
        }

        // 相関チェックをする必要がある場合
        CommonInputReserveInfo.Check({
          ircd: this.$store.state.auth.ircd,
          jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
          nend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
          // カレンダー選択画面で入力した予約日付
          reserveDate: this.$store.state.commonUserInfo.selectCalender.date,
          // 入力画面この画面の
          jgnm: this.inputForm.jgnm,
          jgnmIsErrorCheck: this.inputForm.jgnmIsErrorCheck,
          hksh: this.inputForm.hksh,
          hkshIsErrorCheck: this.inputForm.hkshIsErrorCheck,
          hkkg: this.inputForm.hkkg,
          hkkgIsErrorCheck: this.inputForm.hkkgIsErrorCheck,
          hkno: this.inputForm.hkno,
          hknoIsErrorCheck: this.inputForm.hknoIsErrorCheck,
          hfkb: this.inputForm.hfkb,
          hfkbIsErrorCheck: this.inputForm.hfkbIsErrorCheck,
          cmnm: this.inputForm.cmnm,
          cmnmIsErrorCheck: this.inputForm.cmnmIsErrorCheck,
          nam1: this.inputForm.nam1,
          nam1IsErrorCheck: this.inputForm.nam1IsErrorCheck,
          nam2: this.inputForm.nam2,
          nam2IsErrorCheck: this.inputForm.nam2IsErrorCheck,
          ryk1: this.inputForm.ryk1,
          ryk1IsErrorCheck: this.inputForm.ryk1IsErrorCheck,
          ryk2: this.inputForm.ryk2,
          ryk2IsErrorCheck: this.inputForm.ryk2IsErrorCheck,
          btdyYear: this.inputForm.btdyYear,
          btdyYearIsInput: this.inputForm.btdyYearIsInput,
          btdyYearIsErrorCheck: this.inputForm.btdyYearIsErrorCheck,
          btdyMonth: this.inputForm.btdyMonth,
          btdyMonthIsInput: this.inputForm.btdyMonthIsInput,
          btdyMonthIsErrorCheck: this.inputForm.btdyMonthIsErrorCheck,
          btdyDate: this.inputForm.btdyDate,
          btdyDateIsInput: this.inputForm.btdyDateIsInput,
          btdyDateIsErrorCheck: this.inputForm.btdyDateIsErrorCheck,
          sex: this.inputForm.sex,
          sexIsErrorCheck: this.inputForm.sexIsErrorCheck,
          zip1: this.inputForm.zip1,
          zip1IsErrorCheck: this.inputForm.zip1IsErrorCheck,
          zip2: this.inputForm.zip2,
          zip2IsErrorCheck: this.inputForm.zip2IsErrorCheck,
          adr1: this.inputForm.adr1,
          adr1IsErrorCheck: this.inputForm.adr1IsErrorCheck,
          adr2: this.inputForm.adr2,
          adr2IsErrorCheck: this.inputForm.adr2IsErrorCheck,
          adr3: this.inputForm.adr3,
          adr3IsErrorCheck: this.inputForm.adr3IsErrorCheck,
          tel1: this.inputForm.tel1,
          tel1IsErrorCheck: this.inputForm.tel1IsErrorCheck,
          syno: this.inputForm.syno,
          synoIsErrorCheck: this.inputForm.synoIsErrorCheck,
          email1: this.inputForm.email1,
          email1IsErrorCheck: this.inputForm.email1IsErrorCheck,
          email2: this.inputForm.email2,
          email2IsErrorCheck: this.inputForm.email2IsErrorCheck,
          dmkb: this.inputForm.dmkb,
          dmkbIsErrorCheck: this.inputForm.dmkbIsErrorCheck,
          mem1: this.inputForm.mem1,
          mem1IsErrorCheck: this.inputForm.mem1IsErrorCheck
        }).then(({ responce }) => {

            // 生年月日が入力可能ならば年齢をサーバー側で計算する
            // そうでない場合はストアに保存されている値
            // 前画面から引き継いだ値を使用する
            var tempAge = 0
            if(this.inputForm.btdyYearIsInput
              && this.inputForm.btdyMonthIsInput
              && this.inputForm.btdyDateIsInput) {
              tempAge = responce.data.age
            } else {
              tempAge = this.$store.state.commonUserInfo.newHealthInsurance.age
            }

            // 画面の値をストアに保存
            this.saveStore(tempAge)

            // 予約確認画面に遷移
            this.$router.push("/CommonConfirmReserveInfo")

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onNext End')
	      })

      },
      // 戻るボタン押下時
      onBack: function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onBack Start')

        // ストアの値をリセット
        this.$store.commit(
          types.COMMON_INPUTRESERVEINFO_BACK)

        // カレンダー選択画面へ遷移
        this.$router.push("/CommonSelectCalender")

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onBack End')

      },
      // 画面の値をストアに保存
      saveStore: function(in_age){
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::saveStore Start')

        var tempJgnm = ''
        var tempHksh = ''
        var tempHkkg = ''
        var tempHkno = ''
        var tempHfkb = ''
        var tempCmnm = ''
        var tempNam1 = ''
        var tempNam2 = ''
        var tempRyk1 = ''
        var tempRyk2 = ''
        var tempBtdyYear = 0
        var tempBtdyMonth = 0
        var tempBtdyDate = 0
        var tempAge = 0
        var tempSex = ''
        var tempZip1 = ''
        var tempZip2 = ''
        var tempAdr1 = ''
        var tempAdr2 = ''
        var tempAdr3 = ''
        var tempTel1 = ''
        var tempSyno = ''
        var tempEmail1 = ''
        var tempDmkb = ''
        var tempMem1 = ''

        // 健康保険組合名（新規健保予約画面でも更新可能性あり）
        tempJgnm = this.inputForm.jgnm

        // 保険者番号（新規健保予約画面でも更新可能性あり）
        tempHksh = this.inputForm.hksh

        // 保険証記号
        tempHkkg = this.inputForm.hkkg

        // 保険証番号
        tempHkno = this.inputForm.hkno

        // 対象者区分（新規健保予約画面でも更新可能性あり）
        tempHfkb = this.inputForm.hfkb

        // 企業名
        tempCmnm = this.inputForm.cmnm

        // 漢字氏名 姓
        tempNam1 = this.inputForm.nam1

        // 漢字氏名 名
        tempNam2 = this.inputForm.nam2

        // カナ氏名 姓
        tempRyk1 = this.inputForm.ryk1

        // カナ氏名 名
        tempRyk2 = this.inputForm.ryk2

        // 生年月日 年（新規健保予約画面でも更新可能性あり）
        tempBtdyYear = this.inputForm.btdyYear

        // 生年月日 月（新規健保予約画面でも更新可能性あり）
        tempBtdyMonth = this.inputForm.btdyMonth

        // 生年月日 日（新規健保予約画面でも更新可能性あり）
        tempBtdyDate = this.inputForm.btdyDate

        // 年齢（新規健保予約画面でも更新可能性あり）
        tempAge = in_age

        // 性別（新規健保予約画面でも更新可能性あり）
        tempSex = this.inputForm.sex

        // ご住所 郵便番号 前半
        tempZip1 = this.inputForm.zip1

        // ご住所 郵便番号 後半
        tempZip2 = this.inputForm.zip2

        // ご住所 都道府県
        tempAdr1 = this.inputForm.adr1

        // ご住所 市区町村
        tempAdr2 = this.inputForm.adr2

        // ご住所 番地
        tempAdr3 = this.inputForm.adr3

        // 電話番号
        tempTel1 = this.inputForm.tel1

        // 社員番号
        tempSyno = this.inputForm.syno

        // メールアドレス
        tempEmail1 = this.inputForm.email1

        // ＤＭ・メルマガ
        tempDmkb = this.inputForm.dmkb

        // 備考
        tempMem1 = this.inputForm.mem1

        // ストアに登録
        this.$store.commit(
         types.COMMON_INPUTRESERVEINFO,
         {
           jgnm: tempJgnm,
           hksh: tempHksh,
           hkkg: tempHkkg,
           hkno: tempHkno,
           hfkb: tempHfkb,
           cmnm: tempCmnm,
           nam1: tempNam1,
           nam2: tempNam2,
           ryk1: tempRyk1,
           ryk2: tempRyk2,
           btdyYear: tempBtdyYear,
           btdyMonth: tempBtdyMonth,
           btdyDate: tempBtdyDate,
           age: tempAge,
           sex: tempSex,
           zip1: tempZip1,
           zip2: tempZip2,
           adr1: tempAdr1,
           adr2: tempAdr2,
           adr3: tempAdr3,
           tel1: tempTel1,
           syno: tempSyno,
           email: tempEmail1,
           dmkb: tempDmkb,
           mem1: tempMem1
         })

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::saveStore End')
      },
      // 郵便番号から住所検索
      onAddressSearch: function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onAddressSearch Start')

        // :TODO　共通のチェック関数を作る
        var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)

        if (this.inputForm.zip1.length != 3
          || !regexp.test(this.inputForm.zip1)) {
          return
        }

        if (this.inputForm.zip2.length != 4
          || !regexp.test(this.inputForm.zip2)) {
          return
        }

        var tempZip = this.inputForm.zip1 + '- ' + this.inputForm.zip2

        new YubinBango.Core(tempZip, (addr) => {
          if (addr.region_id) {
            this.inputForm.adr1 = addr.region
            this.inputForm.adr2 = addr.locality + addr.street;
          }
          UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onAddressSearch End')
        })
      },
      // イベント系--------------------------------------------------E
      // その他--------------------------------------------------S
      // リアクティブエラー処理 クライアントコード
      reactiveValidationJgnm :function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationJgnm Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.jgnmInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.jgnm)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.jgnmInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationJgnm('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.jgnmMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.jgnmMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationJgnm End')
      },
      // リアクティブエラー処理 保険者番号
      reactiveValidationHksh:function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHksh Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.hkshInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.hksh)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.hkshInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationHksh('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.hkshMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.hkshMessage = ''
        }
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHksh End')
      },
      // リアクティブエラー 保険証記号
      reactiveValidationHkkg:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHkkg Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.hkkgInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.hkkg)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.hkkgInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationHkkg('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.hkkgMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.hkkgMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHkkg End')
      },
      // リアクティブエラー 保険証番号
      reactiveValidationHkno:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHkno Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.hknoInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.hkno)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.hknoInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationHkno('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.hknoMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.hknoMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHkno End')
      },
      // リアクティブエラー 対象者区分
      reactiveValidationHfkb:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHfkb Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.hfkbInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.hfkb)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.hfkbInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationHfkb('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.hfkbMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.hfkbMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationHfkb End')
      },
      // リアクティブエラー 企業名
      reactiveValidationCmnm:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationCmnm Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.cmnmInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.cmnm)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.cmnmInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationCmnm('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.cmnmMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.cmnmMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationCmnm End')
      },
      // リアクティブエラー 漢字氏名
      reactiveValidationName:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationName Start')

        var tempErrorMessage = []
        var tempErrorMessageNam1 = []
        var tempErrorMessageNam2 = []

        // 漢字氏名（姓）一度も入力していない場合
        if(!this.reactiveValidationError.nam1InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.nam1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.nam1InputFlag = true
          }
        }

        // 漢字氏名（名）一度も入力していない場合
        if(!this.reactiveValidationError.nam2InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.nam2)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.nam2InputFlag = true
          }
        }

        // 必須項目のうち一度も入力していない項目が一つでもある場合
        if(!this.reactiveValidationError.nam1InputFlag
            || !this.reactiveValidationError.nam2InputFlag) {
            return
        }

        // リアクティブエラーチェック　漢字氏名（姓）
        tempErrorMessageNam1 = this.validationNam1('0')
        tempErrorMessageNam1.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　漢字氏名（名）
        tempErrorMessageNam2 = this.validationNam2('0')
        tempErrorMessageNam2.forEach(
          item => tempErrorMessage.push(item)
        )

        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.nameMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.nameMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationName End')
      },
      // リアクティブエラー カナ氏名
      reactiveValidationRyk:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationRyk Start')

        var tempErrorMessage = []
        var tempErrorMessageRyk1 = []
        var tempErrorMessageRyk2 = []

        // カナ氏名（姓）一度も入力していない場合
        if(!this.reactiveValidationError.ryk1InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.ryk1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.ryk1InputFlag = true
          }
        }

        // カナ氏名（名）一度も入力していない場合
        if(!this.reactiveValidationError.ryk2InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.ryk2)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.ryk2InputFlag = true
          }
        }

        // 必須項目のうち一度も入力していない項目が一つでもある場合
        if(!this.reactiveValidationError.ryk1InputFlag
            || !this.reactiveValidationError.ryk2InputFlag) {
            return
        }

        // リアクティブエラーチェック　カナ氏名（姓）
        tempErrorMessageRyk1 = this.validationRyk1('0')
        tempErrorMessageRyk1.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　カナ氏名（名）
        tempErrorMessageRyk2 = this.validationRyk2('0')
        tempErrorMessageRyk2.forEach(
          item => tempErrorMessage.push(item)
        )

        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.rykMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.rykMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationRyk End')
      },
      // リアクティブエラー 生年月日
      reactiveValidationBtdy:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationBtdy Start')

        var tempErrorMessage = []
        var tempErrorMessageBtdyYear = []
        var tempErrorMessageBtdyMonth = []
        var tempErrorMessageBtdyDate = []

        // 生年月日 年 一度も入力していない場合
        if(!this.reactiveValidationError.btdyYearInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.btdyYear)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.btdyYearInputFlag = true
          }
        }

        // 生年月日 月 一度も入力していない場合
        if(!this.reactiveValidationError.btdyMonthInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.btdyMonth)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.btdyMonthInputFlag = true
          }
        }

        // 生年月日 日 一度も入力していない場合
        if(!this.reactiveValidationError.btdyDateInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.btdyDate)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.btdyDateInputFlag = true
          }
        }

        // 必須項目のうち一度も入力していない項目が一つでもある場合
        if(!this.reactiveValidationError.btdyDateInputFlag
            || !this.reactiveValidationError.btdyMonthInputFlag
            || !this.reactiveValidationError.btdyDateInputFlag) {
            return
        }

        // リアクティブエラーチェック　生年月日 年
        tempErrorMessageBtdyYear = this.validationBtdyYear('0')
        tempErrorMessageBtdyYear.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　生年月日 月
        tempErrorMessageBtdyMonth = this.validationBtdyMonth('0')
        tempErrorMessageBtdyMonth.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　生年月日 日
        tempErrorMessageBtdyDate = this.validationBtdyDate('0')
        tempErrorMessageBtdyDate.forEach(
          item => tempErrorMessage.push(item)
        )

        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.btdyMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.btdyMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationBtdy End')
      },
      // リアクティブエラー 性別
      reactiveValidationSex:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationSex Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.sexInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.sex)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.sexInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationSex('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.sexMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.sexMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationSex End')
      },
      // リアクティブエラー 住所
      reactiveValidationZipAddress:function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationZipAddress Start')

        var tempErrorMessage = []
        var tempErrorMessageZip1 = []
        var tempErrorMessageZip2 = []
        var tempErrorMessageAdr1 = []
        var tempErrorMessageAdr2 = []
        var tempErrorMessageAdr3 = []

        // 郵便番号 前半 一度も入力していない場合
        if(!this.reactiveValidationError.zip1InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.zip1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.zip1InputFlag = true
          }
        }

        // 郵便番号 後半 一度も入力していない場合
        if(!this.reactiveValidationError.zip2InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.zip2)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.zip2InputFlag = true
          }
        }

        // 都道府県 一度も入力していない場合
        if(!this.reactiveValidationError.adr1InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.adr1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.adr1InputFlag = true
          }
        }

        // 市区町村 一度も入力していない場合
        if(!this.reactiveValidationError.adr2InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.adr2)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.adr2InputFlag = true
          }
        }

        // 必須項目のうち一度も入力していない項目が一つでもある場合
        if(!this.reactiveValidationError.zip1InputFlag
            || !this.reactiveValidationError.zip2InputFlag
            || !this.reactiveValidationError.adr1InputFlag
            || !this.reactiveValidationError.adr2InputFlag) {
            return
        }

        // リアクティブエラーチェック　郵便番号 前半
        tempErrorMessageZip1 = this.validationZip1('0')
        tempErrorMessageZip1.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　郵便番号 後半
        tempErrorMessageZip2 = this.validationZip2('0')
        tempErrorMessageZip2.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　都道府県
        tempErrorMessageAdr1 = this.validationAdr1('0')
        tempErrorMessageAdr1.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　市区町村
        tempErrorMessageAdr2 = this.validationAdr2('0')
        tempErrorMessageAdr2.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　番地
        tempErrorMessageAdr3 = this.validationAdr3('0')
        tempErrorMessageAdr3.forEach(
          item => tempErrorMessage.push(item)
        )

        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.zipAddressMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.zipAddressMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationZipAddress End')
      },
      // リアクティブエラー 電話番号
      reactiveValidationTel1:function() {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationTel1 Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.tel1InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.tel1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.tel1InputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationTel1('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.tel1Message = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.tel1Message = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationTel1 End')
      },
      // リアクティブエラー 社員番号
      reactiveValidationSyno:function() {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationSyno Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.synoInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.syno)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.synoInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationSyno('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.synoMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.synoMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationSyno End')
      },
      // リアクティブエラー メールアドレス
      reactiveValidationEmail:function() {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationEmail Start')

        var tempErrorMessage = []
        var tempErrorMessageEmail1 = []
        var tempErrorMessageEmail2 = []
        var tempErrorMessageEmail12 = []

        // メールアドレス一度も入力していない場合
        if(!this.reactiveValidationError.email1IsInput) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.email1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.email1IsInput = true
          }
        }

        // メールアドレス（確認用）一度も入力していない場合
        if(!this.reactiveValidationError.email2IsInput) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.email2)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.email2IsInput = true
          }
        }

        // 必須項目のうち一度も入力していない項目が一つでもある場合
        if(!this.reactiveValidationError.email1IsInput
            || !this.reactiveValidationError.email2IsInput) {
            return
        }

        // リアクティブエラーチェック　メールアドレス
        tempErrorMessageEmail1 = this.validationEmail1('0')
        tempErrorMessageEmail1.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　メールアドレス（確認用）
        tempErrorMessageEmail2 = this.validationEmail2('0')
        tempErrorMessageEmail2.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック 相関チェック
        tempErrorMessageEmail12 = this.validationEmail12(
          this.inputForm.email1,this.inputForm.email2
        )
        tempErrorMessageEmail12.forEach(
          item => tempErrorMessage.push(item)
        )

        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.emailMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.emailMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationEmail End')
      },
      // リアクティブエラー ＤＭ・メルマガ
      reactiveValidationDmkb:function() {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationDmkb Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.dmkbInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.dmkb)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.dmkbInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationDmkb('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.dmkbMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.dmkbMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationDmkb End')
      },
      // リアクティブエラー 備考
      reactiveValidationMem1:function() {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationMem1 Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.mem1InputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.mem1)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.mem1InputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationMem1('0')
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.mem1Message = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.mem1Message = ''
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::reactiveValidationMem1 End')
      },
      // 予約するボタン押下時入力チェック
      validationOnNext: function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationOnNext Start')

        // エラーメッセージリスト
        var errorMessagesList = []

        var tempErrorMessageJgnm = []
        var tempErrorMessageHksh = []
        var tempErrorMessageHkkg = []
        var tempErrorMessageHkno = []
        var tempErrorMessageHfkb = []
        var tempErrorMessageCmnm = []
        var tempErrorMessageNam1 = []
        var tempErrorMessageNam2 = []
        var tempErrorMessageRyk1 = []
        var tempErrorMessageRyk2 = []
        var tempErrorMessageBtdyYear = []
        var tempErrorMessageBtdyMonth = []
        var tempErrorMessageBtdyDate = []
        var tempErrorMessageSex = []
        var tempErrorMessageZip1 = []
        var tempErrorMessageZip2 = []
        var tempErrorMessageAdr1 = []
        var tempErrorMessageAdr2 = []
        var tempErrorMessageAdr3 = []
        var tempErrorMessageTel1 = []
        var tempErrorMessageSyno = []
        var tempErrorMessageEmail1 = []
        var tempErrorMessageEmail2 = []
        var tempErrorMessageEmail12 = []
        var tempErrorMessageDmkb = []
        var tempErrorMessageMem1 = []

        // 健康保険組合名 入力チェック
        tempErrorMessageJgnm = this.validationJgnm('1')
        tempErrorMessageJgnm.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 保険者番号 入力チェック
        tempErrorMessageHksh = this.validationHksh('1')
        tempErrorMessageHksh.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 保険証記号 入力チェック
        tempErrorMessageHkkg = this.validationHkkg('1')
        tempErrorMessageHkkg.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 保険証番号 入力チェック
        tempErrorMessageHkno = this.validationHkno('1')
        tempErrorMessageHkno.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 対象者区分 入力チェック
        tempErrorMessageHfkb = this.validationHfkb('1')
        tempErrorMessageHfkb.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 企業名 入力チェック
        tempErrorMessageCmnm = this.validationCmnm('1')
        tempErrorMessageCmnm.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 氏名（姓） 入力チェック
        tempErrorMessageNam1 = this.validationNam1('1')
        tempErrorMessageNam1.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 氏名（名） 入力チェック
        tempErrorMessageNam2 = this.validationNam2('1')
        tempErrorMessageNam2.forEach((item) => {
          errorMessagesList.push(item)
        })

        // カナ氏名（姓） 入力チェック
        tempErrorMessageRyk1 = this.validationRyk1('1')
        tempErrorMessageRyk1.forEach((item) => {
          errorMessagesList.push(item)
        })

        // カナ氏名（名） 入力チェック
        tempErrorMessageRyk2 = this.validationRyk2('1')
        tempErrorMessageRyk2.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 生年月日　年 入力チェック
        tempErrorMessageBtdyYear = this.validationBtdyYear('1')
        tempErrorMessageBtdyYear.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 生年月日　月 入力チェック
        tempErrorMessageBtdyMonth = this.validationBtdyMonth('1')
        tempErrorMessageBtdyMonth.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 生年月日　日 入力チェック
        tempErrorMessageBtdyDate = this.validationBtdyDate('1')
        tempErrorMessageBtdyDate.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 性別の入力チェック
        tempErrorMessageSex = this.validationSex('1')
        tempErrorMessageSex.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 住所 郵便番号 前半 入力チェック
        tempErrorMessageZip1 = this.validationZip1('1')
        tempErrorMessageZip1.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 住所 郵便番号 後半 入力チェック
        tempErrorMessageZip2 = this.validationZip2('1')
        tempErrorMessageZip2.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 住所 都道府県 入力チェック
        tempErrorMessageAdr1 = this.validationAdr1('1')
        tempErrorMessageAdr1.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 住所 市区町村 入力チェック
        tempErrorMessageAdr2 = this.validationAdr2('1')
        tempErrorMessageAdr2.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 住所 番地 入力チェック
        tempErrorMessageAdr3 = this.validationAdr3('1')
        tempErrorMessageAdr3.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 電話番号 入力チェック
        tempErrorMessageTel1 = this.validationTel1('1')
        tempErrorMessageTel1.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 社員番号 入力チェック
        tempErrorMessageSyno = this.validationSyno('1')
        tempErrorMessageSyno.forEach((item) => {
          errorMessagesList.push(item)
        })

        // メールアドレス 入力チェック
        tempErrorMessageEmail1 = this.validationEmail1('1')
        tempErrorMessageEmail1.forEach((item) => {
          errorMessagesList.push(item)
        })

        // メールアドレス（確認用） 入力チェック
        tempErrorMessageEmail2 = this.validationEmail2('1')
        tempErrorMessageEmail2.forEach((item) => {
          errorMessagesList.push(item)
        })

        // メールアドレスとメールアドレス（確認用）の相関チェック
        tempErrorMessageEmail12 = this.validationEmail12(
          this.inputForm.email1,this.inputForm.email2)
        tempErrorMessageEmail12.forEach((item) => {
          errorMessagesList.push(item)
        })

        // ＤＭ・メルマガ 入力チェック
        tempErrorMessageDmkb = this.validationDmkb('1')
        tempErrorMessageDmkb.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 備考 入力チェック
        tempErrorMessageMem1 = this.validationMem1('1')
        tempErrorMessageMem1.forEach((item) => {
          errorMessagesList.push(item)
        })

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationOnNext End')

        return errorMessagesList
      },
      // 健康保険組合名入力チェック
      // '0': リアクティブエラーチェック時
      // '1': エラーチェック時
      validationJgnm: function(in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationJgnm Start')

        var propertyName = '健康保険組合名'
        var maxByteLength = 120

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.jgnmIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.jgnmIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.jgnmIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.jgnmIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.jgnm)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.jgnm)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(this.inputForm.jgnm && !UtilityValidation.checkStrMaxByteLength(this.inputForm.jgnm,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationJgnm End')

        return errorMessagesList
      },
      // 保険者番号入力チェック（入力可にならないのでデッドコード）
      validationHksh: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHksh Start')

        var propertyName = '保険者番号'
        var length = 8

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.hkshIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.hkshIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.hkshIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.hkshIsErrorCheck)
        ) {
              if (UtilityValidation.checkStrIsNull(this.inputForm.hksh)) { // Nullチェック

                errorMessagesList.push(
                  UtilityValidation.getErrorMessageCheckStrIsNull(
                    propertyName))
              } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.hksh)) { // 空文字チェック

                errorMessagesList.push(
                  UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                    propertyName))
              }
        }

        if (!UtilityValidation.checkStrHalfWidthNumeric(this.inputForm.hksh)) {
          // 半角数字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrHalfWidthNumeric(
              propertyName))
        } else if (!UtilityValidation.checkStrLength(this.inputForm.hksh, length)) {
          // 桁数チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrLength(
              propertyName, String(length)))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHksh End')

        return errorMessagesList
      },
      // 保険証記号入力チェック
      validationHkkg: function (in_checkType) {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHkkg Start')

        var propertyName = '保険証記号'
        var maxByteLength = 15

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.hkkgIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.hkkgIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.hkkgIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.hkkgIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.hkkg)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.hkkg)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(this.inputForm.hkkg && !UtilityValidation.checkStrIsKaraMoji(this.inputForm.hkkg)
          && !UtilityValidation.checkStrMaxByteLength(this.inputForm.hkkg,maxByteLength)){
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrByteLength(
              propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHkkg End')

        return errorMessagesList
      },
      // 保険証番号入力チェック
      validationHkno: function (in_checkType) {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHkno Start')

        var propertyName = '保険証番号'
        var maxLength = 15

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.hknoIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.hknoIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.hknoIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.hknoIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.hkno)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.hkno)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        if(!UtilityValidation.checkStrIsKaraMoji(this.inputForm.hkno)
          && !UtilityValidation.checkStrHalfWidthNumeric(this.inputForm.hkno)){
          // 半角数字チェック
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrHalfWidthNumeric(
            propertyName
          ))
        } else if(!UtilityValidation.checkStrMaxLength(this.inputForm.hkno,maxLength)){
          // 最大文字数チェック
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrMaxLength(
            propertyName,maxLength
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHkno End')

        return errorMessagesList
      },
      // 対象者区分の入力チェック
      validationHfkb: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHfkbHfkb Start')

        var propertyName = '対象者区分'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.hfkbIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.hfkbIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.hfkbIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.hfkbIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.hfkb)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.hfkb)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationHfkbHfkb End')

        return errorMessagesList
      },
      // 企業名の入力チェック
      validationCmnm: function(in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationCmnm Start')

        var propertyName = '企業名'
        var maxByteLength = 120

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.cmnmIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.cmnmIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.cmnmIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.cmnmIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.cmnm)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.cmnm)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(this.inputForm.cmnm && !UtilityValidation.checkStrMaxByteLength(this.inputForm.cmnm,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationCmnm End')

        return errorMessagesList

      },
      // 氏名（姓）の入力チェック
      validationNam1: function(in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationNam1 Start')

        var propertyName = '氏名（姓）'
        var maxByteLength = 30

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.nam1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.nam1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.nam1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.nam1IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.nam1)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.nam1)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(!UtilityValidation.checkStrMaxByteLength(this.inputForm.nam1,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationNam1 End')

        return errorMessagesList
      },
      // 氏名（名）の入力チェック
      validationNam2: function(in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationNam2 Start')

        var propertyName = '氏名（名）'
        var maxByteLength = 30

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.nam2IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.nam2IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.nam2IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.nam2IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.nam2)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.nam2)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(!UtilityValidation.checkStrMaxByteLength(this.inputForm.nam2,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationNam2 End')

        return errorMessagesList
      },
      // カナ氏名（姓）の入力チェック
      validationRyk1: function(in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationRyk1 Start')

        var propertyName = 'カナ氏名（姓）'
        var maxByteLength = 30

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.ryk1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.ryk1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.ryk1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.ryk1IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.ryk1)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.ryk1)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(!UtilityValidation.checkStrMaxByteLength(this.inputForm.ryk1,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationRyk1 End')

        return errorMessagesList
      },
      // カナ氏名（名）の入力チェック
      validationRyk2: function(in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationRyk2 Start')

        var propertyName = 'カナ氏名（名）'
        var maxByteLength = 30

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.ryk2IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.ryk2IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.ryk2IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.ryk2IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.ryk2)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.ryk2)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(!UtilityValidation.checkStrMaxByteLength(this.inputForm.ryk2,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationRyk2 End')

        return errorMessagesList
      },
      // 生年月日　年の入力チェック
      validationBtdyYear: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationBtdyYear Start')

        var propertyName = '生年月日　年'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.btdyYearIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.btdyYearIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.btdyYearIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.btdyYearIsErrorCheck)
        ) {
          // 初期値
          if (this.inputForm.btdyYear == 0 ) {
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationBtdyYear End')

        return errorMessagesList
      },
      // 生年月日　月の入力チェック
      validationBtdyMonth: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationBtdyMonth Start')

        var propertyName = '生年月日　月'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.btdyMonthIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.btdyMonthIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.btdyMonthIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.btdyMonthIsErrorCheck)
        ) {
          // 初期値
          if (this.inputForm.btdyMonth == 0 ) {
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationBtdyMonth End')

        return errorMessagesList
      },
      // 生年月日　日の入力チェック
      validationBtdyDate: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationBtdyDate Start')

        var propertyName = '生年月日　日'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.btdyDateIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.btdyDateIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.btdyDateIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.btdyDateIsErrorCheck)
        ) {
          // 初期値
          if (this.inputForm.btdyDate == 0 ) {
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationBtdyDate End')

        return errorMessagesList
      },
      // 性別の入力チェック
      validationSex: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationSex Start')

        var propertyNameSex = '性別'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.sexIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.sexIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.sexIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.sexIsErrorCheck)
        ) {
          if (UtilityValidation.checkStrIsNull(this.inputForm.sex)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyNameSex))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.sex)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyNameSex))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationSex End')

        return errorMessagesList
      },
      // 住所 郵便番号 前半 入力チェック
      validationZip1: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationZip1 Start')

        var propertyName = '住所 郵便番号 前半'
        var length = 3

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.zip1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.zip1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.zip1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.zip1IsErrorCheck)
        ) {
              if (UtilityValidation.checkStrIsNull(this.inputForm.zip1)) { // Nullチェック

                errorMessagesList.push(
                  UtilityValidation.getErrorMessageCheckStrIsNull(
                    propertyName))
              } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.zip1)) { // 空文字チェック

                errorMessagesList.push(
                  UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                    propertyName))
              }
        }

        if (!UtilityValidation.checkStrIsKaraMoji(this.inputForm.zip1)
            && !UtilityValidation.checkStrHalfWidthNumeric(this.inputForm.zip1)) { // 半角数字チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrHalfWidthNumeric(
              propertyName))
        }
        else if (!UtilityValidation.checkStrLength(this.inputForm.zip1, length)) { // 桁数チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrLength(
              propertyName, String(length)))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationZip1 End')

        return errorMessagesList
      },
      // 住所 郵便番号 後半 入力チェック
      validationZip2: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationZip2 Start')

        var propertyName = '住所 郵便番号 後半'
        var length = 4

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.zip2IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.zip2IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.zip2IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.zip2IsErrorCheck)
        ) {
              if (UtilityValidation.checkStrIsNull(this.inputForm.zip2)) { // Nullチェック

                errorMessagesList.push(
                  UtilityValidation.getErrorMessageCheckStrIsNull(
                    propertyName))
              } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.zip2InputFlag)) { // 空文字チェック

                errorMessagesList.push(
                  UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                    propertyName))
              }
        }

        if (!UtilityValidation.checkStrIsKaraMoji(this.inputForm.zip2)
            && !UtilityValidation.checkStrHalfWidthNumeric(this.inputForm.zip2)) { // 半角数字チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrHalfWidthNumeric(
              propertyName))
        }
        else if (!UtilityValidation.checkStrLength(this.inputForm.zip2, length)) { // 桁数チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrLength(
              propertyName, String(length)))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationZip2 End')

        return errorMessagesList
      },
      // 住所 都道府県の入力チェック
      validationAdr1: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationAdr1 Start')

        var propertyName = '住所 都道府県'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.adr1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.adr1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.adr1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.adr1IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.adr1)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.adr1)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationAdr1 End')

        return errorMessagesList
      },
      // 住所 市区町村の入力チェック
      validationAdr2: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationAdr2 Start')

        var propertyName = '住所 市区町村'
        var maxByteLength = 120

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.adr2IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.adr2IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.adr2IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.adr2IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.adr2)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.adr2)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(!UtilityValidation.checkStrMaxByteLength(this.inputForm.adr2,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationAdr2 End')

        return errorMessagesList
      },
      // 住所 番地の入力チェック
      validationAdr3: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationAdr3 Start')

        var propertyName = '住所 番地'
        var maxByteLength = 120

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.adr3IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.adr3IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.adr3IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.adr3IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.adr3)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.adr3)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(!UtilityValidation.checkStrMaxByteLength(this.inputForm.adr3,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationAdr3 End')

        return errorMessagesList
      },
      // 電話番号の入力チェック
      validationTel1: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationTel1 Start')

        var propertyName = '電話番号'
        var maxLength = 20

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.tel1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.tel1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.tel1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.tel1IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.tel1)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.tel1)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        if(!UtilityValidation.checkStrIsKaraMoji(this.inputForm.tel1)
          && !UtilityValidation.checkStrTel(this.inputForm.tel1)) {
          // 電話番号の書式を満たしているか
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrTel(
            propertyName
          ))
        } else if(!UtilityValidation.checkStrMaxLength(this.inputForm.tel1,maxLength)){
          // 最大文字数以下を満たしているか
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrMaxLength(
            propertyName,maxLength
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationTel1 End')

        return errorMessagesList
      },
      // 社員番号の入力チェック
      validationSyno: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationSyno Start')

        var propertyName = '社員番号'
        var maxByteLength = 20

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.synoIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.synoIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.synoIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.synoIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.syno)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.syno)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数以下を満たしているか
        if(this.inputForm.syno && !UtilityValidation.checkStrMaxByteLength(this.inputForm.syno,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrMaxByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationSyno End')

        return errorMessagesList
      },
      // メールアドレスの入力チェック
      validationEmail1: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationEmail1 Start')

        var propertyName = 'メールアドレス'
        var maxLength = 60

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.email1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.email1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.email1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.email1IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.email1)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.email1)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        if (!UtilityValidation.checkStrIsKaraMoji(this.inputForm.email1)
            && !UtilityValidation.checkStrEmail(this.inputForm.email1)) {
          // メールアドレスの書式を満たしているか
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrEmail(
            propertyName
          ))
        } else if (!UtilityValidation.checkStrMaxLength(this.inputForm.email1,maxLength)) {
          // 最大文字数以下を満たしているか
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrMaxLength(
            propertyName,maxLength
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationEmail1 End')

        return errorMessagesList
      },
      // メールアドレス（確認用）の入力チェック
      validationEmail2: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationEmail2 Start')

        var propertyName = 'メールアドレス（確認用）'
        var maxLength = 60

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.email2IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.email2IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.email2IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.email2IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.email2)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.email2)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }


        if(!UtilityValidation.checkStrIsKaraMoji(this.inputForm.email2)
            && !UtilityValidation.checkStrEmail(this.inputForm.email2)){
          // メールアドレスの書式を満たしているか
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrEmail(
              propertyName
          ))
        } else if(!UtilityValidation.checkStrMaxLength(this.inputForm.email2,maxLength)) {
          // 最大文字数以下を満たしているか
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrMaxLength(
              propertyName,maxLength
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationEmail2 End')

        return errorMessagesList
      },
      // メールアドレスとメールアドレス（確認用）の相関チェック
      validationEmail12: function(in_email1,in_email2) {

        var resultErrorMessage = []

        // メールアドレスとメールアドレス（確認用）が相違する場合
        if(in_email1 != in_email2) {
          resultErrorMessage.push('メールアドレスとメールアドレス（確認用）に入力されている内容が相違しています。')
        }

        return resultErrorMessage
      },
      // ＤＭ・メルマガの入力チェック
      validationDmkb: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationDmkb Start')

        var propertyName = 'ＤＭ・メルマガ'

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.dmkbIsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.dmkbIsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.dmkbIsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.dmkbIsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.dmkb)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.dmkb)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationDmkb End')

        return errorMessagesList
      },
      // 備考の入力チェック
      validationMem1: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationMem1 Start')

        var propertyName = '備考'
        var maxByteLength = 1000

        // エラーメッセージリスト
        var errorMessagesList = []

        // リアクティブエラーチェック時にエラーチェック行わない場合
        if('0' == in_checkType
           && this.inputForm.codeReactiveErrorCheckNone == this.inputForm.mem1IsReactiveErrorCheck) {
             return errorMessagesList
        }
        // エラーチェック時にエラーチェック行わない場合
        if('1' == in_checkType
          && this.inputForm.codeErrorCheckNone == this.inputForm.mem1IsErrorCheck) {
            return errorMessagesList
        }

        // リアクティブエラーチェック時及び、エラーチェック時に
        // 必須チェックを行う場合
        if( ('0' == in_checkType
             && this.inputForm.codeReactiveErrorCheckRequired == this.inputForm.mem1IsReactiveErrorCheck)
            || ('1' == in_checkType
              && this.inputForm.codeErrorCheckRequired == this.inputForm.mem1IsErrorCheck)
        ) {

          if (UtilityValidation.checkStrIsNull(this.inputForm.mem1)) { // Nullチェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsNull(
                propertyName))
          } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.mem1)) { // 空文字チェック
            errorMessagesList.push(
              UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
                propertyName))
          }
        }

        // 最大バイト数チェック
        if(this.inputForm.mem1 && !UtilityValidation.checkStrMaxByteLength(this.inputForm.mem1,maxByteLength)){
          errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrByteLength(
            propertyName
          ))
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::validationMem1 End')

        return errorMessagesList
      },
      // マイページ経由かつ新規予約（個人）の時-----S
      // 入力項目　表示非表示、活性非活性（入力可能不可能）、初期値の設定
      setInitializeValue: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValue Start')

        if(this.codeUserTypeMyPageNewIndividual == this.userType) {
          // 0: マイページ経由かつ新規予約（個人）
          this.setInitializeValueMyPageNewIndividual()
        } else if(this.codeUserTypeMyPageNewHealth == this.userType) {
          // 1: マイページ経由かつ新規予約（健保）
          this.setInitializeValueMyPageNewHealth()
        } else if(this.codeUserTypeMyPageChangeIndividual == this.userType) {
          // 2: マイページ経由かつ予約変更（個人）
          this.setInitializeValueMyPageChangeIndividual()
        } else if(this.codeUserTypeMyPageChangeHealth == this.userType) {
          // 3: マイページ経由かつ予約変更（健保）
          this.setInitializeValueMyPageChangeHealth()
        } else if(this.codeUserTypeGuestNewIndividual == this.userType) {
          // 4: ゲストログインかつ新規予約（個人）
          this.setInitializeValueGuestNewIndividual()
        } else if(this.codeUserTypeGuestNewHealth == this.userType) {
          // 5: ゲストログインかつ新規予約（健保）
          this.setInitializeValueGuestNewHealth()
        } else if(this.codeUserTypeEnRouteNewIndividual == this.userType) {
          // 6: 途中ログインかつ新規予約（個人）
          this.setInitializeValueEnRouteNewIndividual()
        } else if(this.codeUserTypeEnRouteNewHealth == this.userType) {
          // 7: 途中ログインかつ新規予約（健保）
          this.setInitializeValueEnRouteNewHealth()
        }

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValue End')
      },
      // 0: マイページ経由かつ新規予約（個人）時の各項目初期化
      setInitializeValueMyPageNewIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageNewIndividual Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = true
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNoRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.jgnmInputFlag = true

        // 保険者番号
        this.inputForm.hkshIsDisplay = false
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = true
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hfkbInputFlag = true

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam1InputFlag = true

        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam2InputFlag = true

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk1InputFlag = true
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk2InputFlag = true

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = true
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyYearInputFlag = true

        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = true
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyMonthInputFlag = true

        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = true
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyDateInputFlag = true

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = true
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.sexInputFlag = true

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip1InputFlag = true
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip2InputFlag = true
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr1InputFlag = true
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr2InputFlag = true
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.tel1InputFlag = true

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.email1InputFlag = true

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        // this.reactiveValidationError.email2InputFlag = true

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = true
        this.inputForm.dmkbIsInput = true
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.dmkbInputFlag = true

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageNewIndividual End')
      },
      // 1: マイページ経由かつ新規予約（健保）時の各項目初期化
      setInitializeValueMyPageNewHealth: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageNewHealth Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = false
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険者番号
        this.inputForm.hkshIsDisplay = true
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hkkgInputFlag = true

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hknoInputFlag = true

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = false
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.cmnmInputFlag = true

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam1InputFlag = true
        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam2InputFlag = true

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk1InputFlag = true
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk2InputFlag = true

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = false
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckNone
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = false
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckNone
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = false
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = false
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckNone

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip1InputFlag = true
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip2InputFlag = true
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr1InputFlag = true
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr2InputFlag = true
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.tel1InputFlag = true

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.email1InputFlag = true

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = false
        this.inputForm.dmkbIsInput = false
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageNewHealth End')
      },
      // 2: マイページ経由かつ予約変更（個人）時の各項目初期化
      setInitializeValueMyPageChangeIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageChangeIndividual Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = true
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNoRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.jgnmInputFlag = true

        // 保険者番号
        this.inputForm.hkshIsDisplay = false
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = true
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hfkbInputFlag = true

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam1InputFlag = true
        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam2InputFlag = true

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk1InputFlag = true
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk2InputFlag = true

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = true
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyYearInputFlag = true
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = true
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyMonthInputFlag = true
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = true
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyDateInputFlag = true

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = true
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip1InputFlag = true
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip2InputFlag = true
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr1InputFlag = true
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr2InputFlag = true
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.tel1InputFlag = true

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.email1InputFlag = true

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = true
        this.inputForm.dmkbIsInput = true
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.dmkbInputFlag = true

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageChangeIndividual End')
      },
      // 3: マイページ経由かつ予約変更（健保）時の各項目初期化
      setInitializeValueMyPageChangeHealth: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageChangeHealth Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = false
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険者番号
        this.inputForm.hkshIsDisplay = true
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hkkgInputFlag = true

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hknoInputFlag = true

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = false
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.cmnmInputFlag = true

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam1InputFlag = true
        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam2InputFlag = true

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk1InputFlag = true
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk2InputFlag = true

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = false
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckNone
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = false
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckNone
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = false
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = false
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckNone

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip1InputFlag = true
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip2InputFlag = true
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr1InputFlag = true
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr2InputFlag = true
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.tel1InputFlag = true

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.email1InputFlag = true

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = false
        this.inputForm.dmkbIsInput = false
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueMyPageChangeHealth End')
      },
      // 4: ゲストログインかつ新規予約（個人）時の各項目初期化
      setInitializeValueGuestNewIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueGuestNewIndividual Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = true
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 保険者番号
        this.inputForm.hkshIsDisplay = false
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = true
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = true
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = true
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = true
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 年齢
        this.inputForm.ageIsDisplay = false
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = true
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = true
        this.inputForm.dmkbIsInput = true
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueGuestNewIndividual End')
      },
      // 5: ゲストログインかつ新規予約（健保）時の各項目初期化
      setInitializeValueGuestNewHealth: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueGuestNewHealth Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = false
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険者番号
        this.inputForm.hkshIsDisplay = true
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = false
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = false
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckNoRequired
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = false
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckNoRequired
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = false
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = false
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckNone

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = false
        this.inputForm.dmkbIsInput = false
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueGuestNewHealth End')
      },
      // 6: 途中ログインかつ新規予約（個人）時の各項目初期化
      setInitializeValueEnRouteNewIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueEnRouteNewIndividual Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = true
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.jgnmInputFlag = true

        // 保険者番号
        this.inputForm.hkshIsDisplay = false
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = true
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hfkbInputFlag = true

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckRequired

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam1InputFlag = true
        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam2InputFlag = true

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk1InputFlag = true
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk2InputFlag = true

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = true
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckRequired
        this.reactiveValidationError.btdyYearInputFlag = true
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = true
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyMonthInputFlag = true
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = true
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.btdyDateInputFlag = true

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = true
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.sexIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.sexInputFlag = true

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip1InputFlag = true

        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip2InputFlag = true

        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr1InputFlag = true

        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr2InputFlag = true

        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.tel1InputFlag = true

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNone

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.email1InputFlag = true

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = true
        this.inputForm.dmkbIsInput = true
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.dmkbInputFlag = true

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueEnRouteNewIndividual End')
      },
      // 7: 途中ログインかつ新規予約（健保）時の各項目初期化
      setInitializeValueEnRouteNewHealth: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueEnRouteNewHealth Start')

        // 健康保険組合名
        this.inputForm.jgnmIsDisplay = true
        this.inputForm.jgnmIsInput = false
        this.inputForm.jgnmInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.jgnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.jgnmIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険者番号
        this.inputForm.hkshIsDisplay = true
        this.inputForm.hkshIsInput = false
        this.inputForm.hkshInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hkshIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hkshIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 保険証記号
        this.inputForm.hkkgIsDisplay = true
        this.inputForm.hkkgIsInput = true
        this.inputForm.hkkgInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hkkgIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hkkgIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hkkgInputFlag = true

        // 保険証番号
        this.inputForm.hknoIsDisplay = true
        this.inputForm.hknoIsInput = true
        this.inputForm.hknoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.hknoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.hknoIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.hknoInputFlag = true

        // 対象者区分
        this.inputForm.hfkbIsDisplay = true
        this.inputForm.hfkbIsInput = false
        this.inputForm.hfkbInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.hfkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.hfkbIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 企業名
        this.inputForm.cmnmIsDisplay = true
        this.inputForm.cmnmIsInput = true
        this.inputForm.cmnmInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.cmnmIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.cmnmIsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.cmnmInputFlag = true

        // 漢字氏名
        // 姓
        this.inputForm.nam1IsDisplay = true
        this.inputForm.nam1IsInput = true
        this.inputForm.nam1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam1InputFlag = true

        // 名
        this.inputForm.nam2IsDisplay = true
        this.inputForm.nam2IsInput = true
        this.inputForm.nam2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.nam2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.nam2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.nam2InputFlag = true

        // カナ氏名
        // 姓
        this.inputForm.ryk1IsDisplay = true
        this.inputForm.ryk1IsInput = true
        this.inputForm.ryk1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk1InputFlag = true
        // 名
        this.inputForm.ryk2IsDisplay = true
        this.inputForm.ryk2IsInput = true
        this.inputForm.ryk2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.ryk2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.ryk2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.ryk2InputFlag = true

        // 生年月日
        // 年
        this.inputForm.btdyYearIsDisplay = true
        this.inputForm.btdyYearIsInput = false
        this.inputForm.btdyYearInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyYearIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.btdyYearIsErrorCheck = this.inputForm.codeErrorCheckNoRequired
        // 月
        this.inputForm.btdyMonthIsDisplay = true
        this.inputForm.btdyMonthIsInput = false
        this.inputForm.btdyMonthInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyMonthIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.btdyMonthIsErrorCheck = this.inputForm.codeErrorCheckNoRequired
        // 日
        this.inputForm.btdyDateIsDisplay = true
        this.inputForm.btdyDateIsInput = false
        this.inputForm.btdyDateInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.btdyDateIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.btdyDateIsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 年齢
        this.inputForm.ageIsDisplay = true
        this.inputForm.ageIsInput = false
        this.inputForm.ageInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.ageIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.ageIsErrorCheck = this.inputForm.codeErrorCheckNone

        // 性別
        this.inputForm.sexIsDisplay = true
        this.inputForm.sexIsInput = false
        this.inputForm.sexInitializeType = this.inputForm.codeInitializeTypeStore
        this.inputForm.sexIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.sexIsErrorCheck = this.inputForm.codeReactiveErrorCheckNone

        // ご住所
        // 郵便番号 前半
        this.inputForm.zip1IsDisplay = true
        this.inputForm.zip1IsInput = true
        this.inputForm.zip1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip1InputFlag = true
        // 郵便番号 後半
        this.inputForm.zip2IsDisplay = true
        this.inputForm.zip2IsInput = true
        this.inputForm.zip2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.zip2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.zip2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.zip2InputFlag = true
        // 都道府県
        this.inputForm.adr1IsDisplay = true
        this.inputForm.adr1IsInput = true
        this.inputForm.adr1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr1InputFlag = true
        // 住所１（市区町村）
        this.inputForm.adr2IsDisplay = true
        this.inputForm.adr2IsInput = true
        this.inputForm.adr2InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.adr2IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.adr2InputFlag = true
        // 住所２（番地）
        this.inputForm.adr3IsDisplay = true
        this.inputForm.adr3IsInput = true
        this.inputForm.adr3InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.adr3IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.adr3IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        // 電話番号
        this.inputForm.tel1IsDisplay = true
        this.inputForm.tel1IsInput = true
        this.inputForm.tel1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.tel1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.tel1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.tel1InputFlag = true

        // 社員番号
        this.inputForm.synoIsDisplay = true
        this.inputForm.synoIsInput = true
        this.inputForm.synoInitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.synoIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.synoIsErrorCheck = this.inputForm.codeErrorCheckNone

        // メールアドレス
        this.inputForm.email1IsDisplay = true
        this.inputForm.email1IsInput = true
        this.inputForm.email1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.email1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email1IsErrorCheck = this.inputForm.codeErrorCheckRequired
        // 初期値があるので入力済みにする
        this.reactiveValidationError.email1InputFlag = true

        this.inputForm.email2IsDisplay = true
        this.inputForm.email2IsInput = true
        this.inputForm.email2InitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.email2IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckRequired
        this.inputForm.email2IsErrorCheck = this.inputForm.codeErrorCheckRequired

        // ＤＭ・メルマガ
        this.inputForm.dmkbIsDisplay = false
        this.inputForm.dmkbIsInput = false
        this.inputForm.dmkbInitializeType = this.inputForm.codeInitializeTypeConstant
        this.inputForm.dmkbIsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNone
        this.inputForm.dmkbIsErrorCheck = this.inputForm.codeErrorCheckNone
        // 初期値があるので入力済みにする
        this.reactiveValidationError.dmkbInputFlag = true

        // 備考
        this.inputForm.mem1IsDisplay = true
        this.inputForm.mem1IsInput = true
        this.inputForm.mem1InitializeType = this.inputForm.codeInitializeTypeDB
        this.inputForm.mem1IsReactiveErrorCheck = this.inputForm.codeReactiveErrorCheckNoRequired
        this.inputForm.mem1IsErrorCheck = this.inputForm.codeErrorCheckNoRequired

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::setInitializeValueEnRouteNewHealth End')
      },
      // 初期化パラメーター(xxxxInitializeType)に基づき初期化
      initialize: function(
        in_jgnm,in_hksh,in_hkkg,in_hkno,in_hfkb,in_cmnm,
        in_nam1,in_nam2,in_ryk1,in_ryk2,
        in_btdyYear,in_btdyMonth,in_btdyDate,in_age,in_sex,
        in_zip1,in_zip2,in_adr1,in_adr2,in_adr3,
        in_tel1,in_syno,in_email,in_dmkb,in_mem1
      ) {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::initialize Start')
        // 健康保険組合名の初期化
        this.initializeJgnm(in_jgnm)
        // 保険者番号の初期化
        this.initializeHksh(in_hksh)
        // 保険証記号の初期化
        this.initializeHkkg(in_hkkg)
        // 保険証番号の初期化
        this.initializeHkno(in_hkno)
        // 対象者区分の初期化
        this.initializeHfkb(in_hfkb)
        // 企業名の初期化
        this.initializeCmnm(in_cmnm)
        // 漢字氏名の初期化
        this.initializeName(in_nam1,in_nam2)
        // カナ氏名の初期化
        this.initializeRyak(in_ryk1,in_ryk2)
        // 生年月日の初期化
        this.initializeBtdy(in_btdyYear,in_btdyMonth,in_btdyDate)
        // 年齢の初期化
        this.initializeAge(in_age)
        // 性別の初期化
        this.initializeSex(in_sex)
        // ご住所 郵便番号～住所２（番地）
        this.initializeZipAddress(in_zip1,in_zip2,in_adr1,in_adr2,in_adr3)
        // 電話番号（日中連絡先）
        this.initializeTel1(in_tel1)
        // 社員番号
        this.initializeSyno(in_syno)
        // メールアドレス
        this.initializeEmail(in_email)
        // ＤＭ・メルマガ
        this.initializeDmkb(in_dmkb)
        // 備考
        this.initializeMem1(in_mem1)

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::initialize End')
      },
      // 健康保険組合名の初期化
      initializeJgnm: function(in_jgnm) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.jgnmInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.jgnm = ''
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.jgnmInitializeType) {
          // ストアから引継ぎ
          this.inputForm.jgnm = in_jgnm
        } else {
          // DBから引継ぎ
          this.inputForm.jgnm = in_jgnm
        }
      },
      // 保険者番号の初期化
      initializeHksh: function(in_hksh) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.hkshInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.hksh = ''
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.hkshInitializeType) {
          // ストアから引継ぎ
          this.inputForm.hksh = this.$store.state.commonUserInfo.newHealthInsurance.hksh
        } else {
          // DBから引継ぎ
          this.inputForm.hksh = in_hksh
        }
      },
      // 保険証記号の初期化
      initializeHkkg: function(in_hkkg) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.hkkgInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.hkkg = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.hkkg = in_hkkg
        }
      },
      // 保険証番号の初期化
      initializeHkno: function(in_hkno) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.hknoInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.hkno = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.hkno = in_hkno
        }
      },
      // 対象者区分の初期化
      initializeHfkb: function(in_hfkb) {

        if(this.inputForm.codeInitializeTypeConstant ==  this.inputForm.hfkbInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.hfkb = ''
        } else if(this.inputForm.codeInitializeTypeStore ==  this.inputForm.hfkbInitializeType) {
          // ストアから引継ぎ
          this.inputForm.hfkb = this.$store.state.commonUserInfo.newHealthInsurance.hfkb
        } else {
          // DBから引継ぎ
          this.inputForm.hfkb = in_hfkb
        }
      },
      // 企業名の初期化
      initializeCmnm: function(in_cmnm) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.cmnmInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.cmnm = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.cmnm = in_cmnm
        }
      },
      // 漢字氏名の初期化
      initializeName: function(in_nam1,in_nam2) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.nam1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.nam1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.nam1 = in_nam1
        }

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.nam2InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.nam2 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.nam2 = in_nam2
        }

      },
      // カナ氏名の初期化
      initializeRyak: function(in_ryk1,in_ryk2) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.ryk1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.ryk1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.ryk1 = in_ryk1
        }

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.ryk2InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.ryk2 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.ryk2 = in_ryk2
        }
      },
      // 生年月日の初期化
      initializeBtdy: function(in_btdyYear,in_btdyMonth,in_btdyDate) {
        // 年
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.btdyYearInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.btdyYear = 0
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.btdyYearInitializeType) {
          // ストアから引継ぎ
          this.inputForm.btdyYear = this.$store.state.commonUserInfo.newHealthInsurance.btdyYear
        } else {
          // DBから引継ぎ
          this.inputForm.btdyYear = in_btdyYear
        }
        // 月
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.btdyMonthInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.btdyMonth = 0
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.btdyMonthInitializeType) {
          // ストアから引継ぎ
          this.inputForm.btdyMonth = this.$store.state.commonUserInfo.newHealthInsurance.btdyMonth
        } else {
          // DBから引継ぎ
          this.inputForm.btdyMonth = in_btdyMonth
        }
        // 日
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.btdyDateInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.btdyDate = 0
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.btdyDateInitializeType) {
          // ストアから引継ぎ
          this.inputForm.btdyDate = this.$store.state.commonUserInfo.newHealthInsurance.btdyDate
        } else {
          // DBから引継ぎ
          this.inputForm.btdyDate = in_btdyDate
        }
      },
      // 年齢の初期化
      initializeAge: function(in_age) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.ageInitializeType){
          this.inputForm.age = 0
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.ageInitializeType) {
          this.inputForm.age = this.$store.state.commonUserInfo.newHealthInsurance.age
        } else {
          this.inputForm.age = in_age
        }

      },
      // 性別の初期化
      initializeSex: function(in_sex) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.sexInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.sex = ''
        } else if(this.inputForm.codeInitializeTypeStore == this.inputForm.sexInitializeType) {
          // ストアから引継ぎ
          this.inputForm.sex = this.$store.state.commonUserInfo.newHealthInsurance.sex
        } else {
          // DBから引継ぎ
          this.inputForm.sex = in_sex
        }
      },
      // ご住所 郵便番号～住所２（番地）
      initializeZipAddress: function(in_zip1,in_zip2,in_adr1,in_adr2,in_adr3) {

        // 郵便番号 前半
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.zip1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.zip1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.zip1 = in_zip1
        }

        // 郵便番号 後半
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.zip2InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.zip2 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.zip2 = in_zip2
        }

        // 都道府県
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.adr1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.adr1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.adr1 = in_adr1
        }

        // 住所１（市区町村）
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.adr2InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.adr2 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.adr2 = in_adr2
        }

        // 住所２（番地）
        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.adr3InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.adr3 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.adr3 = in_adr3
        }

      },
      // 電話番号（日中連絡先）
      initializeTel1: function(in_tel1) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.tel1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.tel1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.tel1 = in_tel1
        }
      },
      // 社員番号
      initializeSyno: function(in_syno) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.synoInitializeType){
          // 初期化タイプが定数の時
          this.inputForm.syno = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.syno = in_syno
        }
      },
      // メールアドレス
      initializeEmail: function(in_email) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.email1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.email1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.email1 = in_email
        }

        // 常に定数（空文字）
        this.inputForm.email2 = ''

      },
      // ＤＭ・メルマガ
      initializeDmkb: function(in_dmkb) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.dmkbInitializeType){
          // 初期化タイプが定数の時 '1':受け取る
          this.inputForm.dmkb = this.inputForm.codeDmkbOK
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.dmkb = in_dmkb
        }

      },
      // 備考
      initializeMem1: function(in_mem1) {

        if(this.inputForm.codeInitializeTypeConstant == this.inputForm.mem1InitializeType){
          // 初期化タイプが定数の時
          this.inputForm.mem1 = ''
        } else {
          // DBから引継ぎ(ストアからの引継ぎはない)
          this.inputForm.mem1 = in_mem1
        }
      },
      // 予約情報確認画面からの戻り遷移時の各値の初期化
      // また、初期値があるので入力済みにする、
      // setInitializeValueXXXXXXXXの後で呼び出す（この関数が後勝ちで上書きする）
      initializeBack: function() {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::initializeBack Start')

        // 健康保険組合名
        this.inputForm.jgnm = this.$store.state.commonUserInfo.inputReserveInfo.jgnm

        // 保険者番号
        this.inputForm.hksh = this.$store.state.commonUserInfo.inputReserveInfo.hksh

        // 保険証記号
        this.inputForm.hkkg = this.$store.state.commonUserInfo.inputReserveInfo.hkkg

        // 保険証番号
        this.inputForm.hkno = this.$store.state.commonUserInfo.inputReserveInfo.hkno

        // 対象者区分
        this.inputForm.hfkb = this.$store.state.commonUserInfo.inputReserveInfo.hfkb

        // 企業名
        this.inputForm.cmnm = this.$store.state.commonUserInfo.inputReserveInfo.cmnm

        // 漢字氏名
        this.inputForm.nam1 = this.$store.state.commonUserInfo.inputReserveInfo.nam1
        this.inputForm.nam2 = this.$store.state.commonUserInfo.inputReserveInfo.nam2

        // カナ氏名
        this.inputForm.ryk1 = this.$store.state.commonUserInfo.inputReserveInfo.ryk1
        this.inputForm.ryk2 = this.$store.state.commonUserInfo.inputReserveInfo.ryk2

        // 生年月日
        this.inputForm.btdyYear = this.$store.state.commonUserInfo.inputReserveInfo.btdyYear
        this.inputForm.btdyMonth = this.$store.state.commonUserInfo.inputReserveInfo.btdyMonth
        this.inputForm.btdyDate = this.$store.state.commonUserInfo.inputReserveInfo.btdyDate

        // 年齢
        this.inputForm.age = this.$store.state.commonUserInfo.inputReserveInfo.age
        // 性別
        this.inputForm.sex = this.$store.state.commonUserInfo.inputReserveInfo.sex
        // 住所
        this.inputForm.zip1 = this.$store.state.commonUserInfo.inputReserveInfo.zip1
        this.inputForm.zip2 = this.$store.state.commonUserInfo.inputReserveInfo.zip2
        this.inputForm.adr1 = this.$store.state.commonUserInfo.inputReserveInfo.adr1
        this.inputForm.adr2 = this.$store.state.commonUserInfo.inputReserveInfo.adr2
        this.inputForm.adr3 = this.$store.state.commonUserInfo.inputReserveInfo.adr3
        // 電話番号（日中連絡先）
        this.inputForm.tel1 = this.$store.state.commonUserInfo.inputReserveInfo.tel1
        // 社員番号
        this.inputForm.syno = this.$store.state.commonUserInfo.inputReserveInfo.syno
        // メールアドレス
        this.inputForm.email1 = this.$store.state.commonUserInfo.inputReserveInfo.email
        this.inputForm.email2 = ''
        // ＤＭ・メルマガ
        this.inputForm.dmkb = this.$store.state.commonUserInfo.inputReserveInfo.dmkb
        // 備考
        this.inputForm.mem1 = this.$store.state.commonUserInfo.inputReserveInfo.mem1

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::initializeBack Start')
      },
      // マイページ経由かつ新規予約（個人）の時-----E
      // ストア値などからユーザータイプを取得
      getUserType: function(in_jgcd){

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::getUserType Start')

      	var resultUserType = ''

      	// マイページ経由、ゲストログイン、途中ログインかどうか
      	if(this.$store.state.commonUserInfo.myPage.isUse) {
      	  // マイページ経由

      	  // 新規予約か予約変更どうか
      	  if(this.$store.state.commonUserInfo.myPage.choiceUkno == '') {
      	    // 新規予約

      	    // 個人か健保かどうか
      	    if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
      	      // 個人
      	      resultUserType = this.codeUserTypeMyPageNewIndividual
      	    } else {
      	      // 健保
      	      resultUserType = this.codeUserTypeMyPageNewHealth
      	    }
      	  } else {
      	    // 予約変更

      	    // 個人か健保かどうか
      	    if('00000000' == in_jgcd){
      	      // 個人
      	      resultUserType = this.codeUserTypeMyPageChangeIndividual
      	    } else {
      	      // 健保
      	      resultUserType = this.codeUserTypeMyPageChangeHealth
      	    }
      	  }
      	} else if(!this.$store.state.commonUserInfo.enRouteLogin.isUse) {
      	  // 途中ログイン
      	  // 個人か健保かどうか
      	  if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
      	    // 個人
      	    resultUserType = this.codeUserTypeGuestNewIndividual
      	  } else {
      	    // 健保
      	    resultUserType = this.codeUserTypeGuestNewHealth
      	  }
      	} else {
      	  // ゲストログイン（マイページ経由、ゲストログイン、途中ログイン）
      	  // 個人か健保かどうか
      	  if(!this.$store.state.commonUserInfo.newHealthInsurance.isUse){
            // 個人
      	    resultUserType = this.codeUserTypeEnRouteNewIndividual
      	  } else {
      	    // 健保
      	    resultUserType = this.codeUserTypeEnRouteNewHealth
      	  }
      	}

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::getUserType End')

      	return resultUserType
      },
      // エラーチェック（リアクティブ）と
      // エラーチェックから必須項目用のクラスを設定
      getRequireClass: function(in_isReactiveErrorCheck,in_isErrorCheck) {

        var resultClassName = ''

        if( this.inputForm.codeReactiveErrorCheckRequired == in_isReactiveErrorCheck
           || this.inputForm.codeErrorCheckRequired == in_isErrorCheck ) {
          resultClassName = 'req'
        }

        return resultClassName
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (errorMessages) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]

				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onValidationErrorModalClose Start')

        this.modal.validationError.messages = []
        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonInputReserveInfo::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
      // その他--------------------------------------------------E
    }
  }</script>



// WEBPACK FOOTER //
// src/components/Common/InputReserveInfo/CommonInputReserveInfo.vue